import PropTypes from "prop-types"
import { replaceWithImgix } from "@lib/utils"
import dynamic from "next/dynamic"

// ---------------------------------------------------------

const Button = dynamic(() => import("@components/button"))

import TagList from "@components/tag-list"

// ---------------------------------------------------------

import { integration_card, card_image, card_meta } from "./styles.module.scss"

// ---------------------------------------------------------

const IntegrationCard = ({ title, image, category, description, sourceUrl, destinationUrl }) => {
  return (
    <div data-testid="integration-card" className={integration_card} role="button" tabIndex={0}>
      <div
        className={card_image}
        data-testid="integration-card-content"
        style={{
          backgroundImage: `url(${replaceWithImgix(image?.src, { w: 250 })}), url(${image?.src})`
        }}
      />
      <div className={card_meta}>
        <h4>{title}</h4>
        <TagList tags={category} />
        <p>{description}</p>
        {sourceUrl && (
          <Button theme="arrow-horizontal-dark" labelAttr="Source docs" url={sourceUrl} />
        )}
        {destinationUrl && (
          <Button theme="arrow-horizontal-dark" labelAttr="Destination docs" url={destinationUrl} />
        )}
      </div>
    </div>
  )
}

IntegrationCard.propTypes = {
  /**
   * Array of categories for the integration.
   */
  category: PropTypes.arrayOf(PropTypes.string),

  /**
   * Name of the integration.
   */
  title: PropTypes.string.isRequired,

  /**
   * Main card image. Usually the logo of the integration.
   */
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }).isRequired,

  /**
   * Describes the integration. Appears when hovering the card.
   */
  description: PropTypes.string.isRequired,

  /**
   * Documentation link to integration as a source
   */
  sourceUrl: PropTypes.string,

  /**
   * Documentation link to integration as a destination
   */
  destinationUrl: PropTypes.string
}

export default IntegrationCard
